export default __webpack_public_path__ + "static/FS2S-InHub-6-4f8280dde539ffafca2e3e6847ac1d82.jpg";